import { ProductCatalogClient } from "@/contentful/product-catalog.tsx";
import { checkFeatureFlagGate } from "@/utils/feature-flags/check-feature-flag";
import { featureFlags } from "@/utils/feature-flags/feature-flag-manifest";
import { isProduction } from "@/utils/urls.ts";

const PRODUCT_CATALOG_DELIVERY_KEY =
    process.env["PRODUCT_CATALOG_DELIVERY_KEY"];
const PRODUCT_CATALOG_SPACE = process.env["PRODUCT_CATALOG_SPACE"];

const PRODUCT_TEMPLATES_ENVIRONMENT =
    process.env["CONTENTFUL_ENVIRONMENT_PRODUCT_TEMPLATES"];
const PRODUCT_TEMPLATES_DELIVERY_KEY =
    process.env["CONTENTFUL_DELIVERY_KEY_PRODUCT_TEMPLATES"];

export const getContentfulContentClient = async () => {
    const { createClient } = await import("contentful");
    return createClient({
        space: "xjcz23wx147q",
        environment: PRODUCT_TEMPLATES_ENVIRONMENT,
        accessToken: String(PRODUCT_TEMPLATES_DELIVERY_KEY)
    });
};

export const getContentfulProductCatalogClient = () => {
    const productCatalogEnvironment = getContentfulProductCatalogEnvironment();
    return new ProductCatalogClient(
        String(PRODUCT_CATALOG_DELIVERY_KEY),
        String(PRODUCT_CATALOG_SPACE),
        productCatalogEnvironment
    );
};

const getContentfulProductCatalogEnvironment = () => {
    if (isProduction()) {
        return "master";
    }
    const isCcpStaging = checkFeatureFlagGate(
        featureFlags.gwp9034WacPricingCcpStaging
    );
    return isCcpStaging ? "ccp_staging" : "master";
};
